import React, { useState } from "react";
import { AddFlex, CustomText, Gap } from "./reusableStyles";
import {
  Currency,
  dashboardFeatureIdentifierBackgroundColor,
  dashboardFeatureIdentifierTextColor,
  formatPrice,
  getFeatureKeyFromFeatureId,
  handleCopyToClipboard,
} from "../utils/utils";
import styled from "styled-components";
import { enqueueSnackbar } from "notistack";
import { Close, ContentCopyOutlined } from "@mui/icons-material";
import { Dialog } from "@mui/material";
import { primaryActionColor } from "../utils/constants";
import { format } from "date-fns";
import TransactionHistoryCard from "./TransactionHistoryCard";

export const Parent = styled.div`
  display: flex;
  flex-direction: row;
  padding: 14px 10px;
  /* justify-content: center; */
  align-items: center;
  /* border: 1px solid #eaecf0; */
  /* box-shadow: 0 0 0 1px #000; */
  overflow: hidden;
  border-top: none;
  ::-webkit-scrollbar {
    display: none;
    width: 0px;
  }
  /* &:hover {
    background-color: #f4f4f4;
  } */
  background-color: transparent;
`;

export const Item = styled.div`
  flex-grow: 1;
  color: #475467;
  display: flex;
  font-size: 14px;
  font-weight: 400;
  justify-content: ${(props) => (props.justify ? props.justify : "center")};
  align-items: ${(props) => (props.align ? props.align : "center")};
  /* flex-basis: ${(props) => (props.isDesktopView ? props.percent : "50%")}; */
  flex-basis: ${(props) => (props.percent ? props.percent : "10%")};
  flex-shrink: 0;
  /* overflow-x: scroll;
  overflow-y: hidden; */
`;

function TransactionTabRow({
  headerList,
  sale,
  saleData,
  date,
  selectedOrders,
  headerCheckboxClicked,
  transactionDetails,
}) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const { name, id } = getFeatureKeyFromFeatureId(
    saleData.featureDetails.featureId
  );
  const getTotalOrderLength = () => {
    let length = 0;
    saleData.customerOrder.forEach((order) => {
      length += order.customerDetails.length;
    });
    return length;
  };

  const getSettledStatus = () => {
    return transactionDetails.status;
  };

  const isSettled = () => {
    return getSettledStatus() === "Settled";
  };

  const StatusChipColors = (status) => {
    if (status === "Pending") {
      return {
        color: "#9e7341",
        border: "1px solid #fdf1da",
        bg: "#fef8ec",
      };
    }
    if (status === "Refunded") {
      return {
        color: "#ababab",
        border: "1px solid #fdf1da",
        bg: "transparent",
      };
    }
    return {
      color: "#337648",
      border: "1px solid #d1f8e2",
      bg: "#ecfdf3",
    };
  };
  return (
    <>
      <Parent
        onClick={() => {
          setOpenDrawer((prev) => !prev);
        }}
      >
        <input
          type="checkbox"
          sx={{
            padding: "0px",
            color: primaryActionColor,
            "&.Mui-checked": {
              color: primaryActionColor,
            },
          }}
          checked={selectedOrders.includes(sale.data.id)}
          onChange={(e) => {
            headerCheckboxClicked(sale.data.id);
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
        <Item justify="center" percent={headerList[0][0]}>
          <AddFlex alignItems="center" flexDirection="column">
            <CustomText fontSize="14px" color="#101828">
              {saleData.bookingCustomerDetails?.name}
            </CustomText>
            <AddFlex margin="4px 0 0 0">
              <CustomText fontSize="12px">
                Booking For {getTotalOrderLength()}
              </CustomText>
            </AddFlex>
          </AddFlex>
        </Item>
        <Item justify="center" percent={headerList[1][0]}>
          <AddFlex alignItems="center" gap="0px" flexDirection="column">
            <CustomText color="#101828">
              {saleData.featureDetails.name}
            </CustomText>
            <AddFlex margin="4px 0 0 0">
              <AddFlex
                alignItems="center"
                padding="4px 10px"
                width="max-content"
                backgroundColor={dashboardFeatureIdentifierBackgroundColor[id]}
                borderRadius="3px"
              >
                <CustomText
                  color={dashboardFeatureIdentifierTextColor[id]}
                  fontSize="12px"
                >
                  {name}
                </CustomText>
              </AddFlex>
            </AddFlex>
          </AddFlex>
        </Item>
        <Item percent={headerList[2][0]}>
          <AddFlex justify="center" gap="12px" align="center">
            <CustomText>{saleData.id}</CustomText>
            <ContentCopyOutlined
              onClick={async (e) => {
                e.stopPropagation();
                handleCopyToClipboard(saleData.id).then(() => {
                  enqueueSnackbar("Order ID copied to clipboard", {
                    variant: "success",
                  });
                });
              }}
              sx={{ fontSize: "14px", color: primaryActionColor }}
            />
          </AddFlex>
        </Item>

        <Item percent={headerList[3][0]}>
          <AddFlex alignItems="center" gap="5px" flexDirection="column">
            <div>{format(new Date(date), "dd MMM yyyy")}</div>
            <div>{format(new Date(date), "hh:mm a")}</div>
          </AddFlex>
        </Item>
        <Item percent={headerList[4][0]}>
          <AmountPaid
            couponCode={saleData.couponCode}
            currency={saleData.paymentBreakdown.currency}
            forexConversionRate={saleData.paymentBreakdown.forexConversionRate}
            totalAmount={saleData.paymentBreakdown.totalAmount}
          />
        </Item>
        <Item percent={headerList[5][0]}>
          <AddFlex alignItems="center" gap="5px" flexDirection="column">
            {isSettled() && (
              <AddFlex justify="center" gap="12px" align="center">
                <CustomText>{transactionDetails.bankUtr}</CustomText>
                {transactionDetails.bankUtr !== "NA" && (
                  <ContentCopyOutlined
                    onClick={async (e) => {
                      e.stopPropagation();
                      handleCopyToClipboard(transactionDetails.bankUtr).then(
                        () => {
                          enqueueSnackbar("Transation ID copied to clipboard", {
                            variant: "success",
                          });
                        }
                      );
                    }}
                    sx={{ fontSize: "14px", color: primaryActionColor }}
                  />
                )}
              </AddFlex>
            )}
            <AddFlex
              padding="3px 15px"
              borderRadius="25px"
              backgroundColor={StatusChipColors(getSettledStatus()).bg}
              color={StatusChipColors(getSettledStatus()).color}
              border={StatusChipColors(getSettledStatus()).border}
              style={{ fontSize: "12px" }}
            >
              {getSettledStatus()}
            </AddFlex>
          </AddFlex>
        </Item>
      </Parent>
      <div
        style={{ backgroundColor: "#ECECEC", width: "100%", height: "1px" }}
      ></div>
      <Dialog
        open={openDrawer}
        onClose={() => {
          setOpenDrawer((prev) => !prev);
        }}
        PaperProps={{
          sx: {
            padding: "20px",
            width: "30vw",
          },
        }}
      >
        <AddFlex flexDirection="column" gap="12px">
          <DialogHeader
            mainText={"Transaction Details"}
            onClose={() => {
              setOpenDrawer((prev) => !prev);
            }}
            style={{
              border: "none",
            }}
          />
          <TransactionHistoryCard transaction={sale} />
        </AddFlex>
      </Dialog>
    </>
  );
}

export default TransactionTabRow;

export const AmountPaid = ({
  totalAmount,
  currency,
  forexConversionRate,
  couponCode,
}) => {
  return (
    <AddFlex gap="8px" flexDirection="column" alignItems="center">
      <CustomText textAlign="center" fontWeight={500} color="#101828">
        {formatPrice(totalAmount, currency)}
        {currency === Currency.USD &&
          ` / ${formatPrice(
            (totalAmount * forexConversionRate) / 100,
            Currency.INR
          )}`}
      </CustomText>
      {couponCode && (
        <CustomText fontSize="10px" fontWeight="600" color="#3a7f53">
          {couponCode}
        </CustomText>
      )}
    </AddFlex>
  );
};

export const DialogHeader = ({
  mainText,
  subText,
  padding,
  style,
  component,
  onClose,
}) => {
  return (
    <AddFlex
      alignItems="center"
      style={
        style
          ? style
          : {
              borderBottom: "1px solid #ececec",
              padding: padding,
              paddingBottom: "8px",
            }
      }
      gap="10px"
    >
      <AddFlex gap="6px" flexDirection="column">
        <CustomText
          fontSize="18px"
          color="black"
          fontWeight="500"
          style={{ lineHeight: "18px" }}
        >
          {mainText}
        </CustomText>
        <CustomText
          color="#667085"
          fontSize="14px"
          fontWeight="300"
          style={{ lineHeight: "18px", letterSpacing: "-0.14px" }}
        >
          {subText}
        </CustomText>
      </AddFlex>
      <Gap />
      {component}
      <Close style={{ cursor: "pointer" }} onClick={onClose} />
    </AddFlex>
  );
};
